import { useMutation } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../api/apiV2';
import type { SetTaskPinnedDto } from '../../../api/generated/v2/generated/data-contracts';

export const usePinTask = () =>
    useMutation({
        mutationFn: (dto: SetTaskPinnedDto) => ApiCallsV2.pinTask(dto),
    });
